import classes from './AddSampleSourceModal.module.css';
import styles from '../../../../Widgets/ModalInfo/modal.module.css';
import baseClasses from '../../../WorkRightUsersDir/WorkRightUserAddMenu/workRightUserAddMenu.module.css';
import dropStyles from '../../../WorkRightStorageDir/WorkRightStorageAddMenu/workRightStorageAddMenuDropdownFirst.module.css';

import error from 'assets/svg/attention-01.svg';
import close from 'assets/svg/close-01.svg';

import Icon from 'helpers/components/Icon';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import WorkRightAddMenuItem from '../../../WorkRightManualDir/WorkRightAddMenu/workRightAddMenuItem';
import { SampleSourceStore } from 'store/context/SampleSourceStore';
import {
  createSampleSource,
  updateSampleSource,
} from 'services/sampleSource.services';
import useAlert from 'hooks/useAlert';
import Select from 'ui/Select';
import classNames from 'classnames';
import { getFileSample } from 'services/sample.services';
import FileSaver from 'file-saver';

const AddSampleSourceModal = ({
  setModalOpened,
  typesSampleSource,
  onUpdate,
  disabled = false,
}) => {
  const { sampleSourceSelected, setSampleSourceField, clearSampleSourceField } =
    React.useContext(SampleSourceStore);
  const { showAlert } = useAlert();

  const [field, setField] = React.useState({
    name: sampleSourceSelected.name ?? '',
    description: sampleSourceSelected.description ?? '',
    user_fields: [],
  });
  const [typesSources] = React.useState(typesSampleSource);
  const [selectedTypeId, setSelectedTypeId] = React.useState(sampleSourceSelected.id_type);
  const [selectedSourceType, setSelectedSourceType] = React.useState(
    typesSources.find((item) => item.id == sampleSourceSelected.id_type),
  );
  const [newUserFields, setNewUserFields] = useState({ id: 0, fields: {} });
  const [isClickAdd, setIsClickAdd] = React.useState(false);

  React.useEffect(() => {
    if (Array.isArray(sampleSourceSelected?.user_fields)) {
      const newSelectItem = { ...newUserFields };

      sampleSourceSelected.user_fields.map((val) => {
        if (val.type.type_name == 'file') {
          const itemValue = JSON.parse(val.value) ?? undefined;
          newSelectItem.fields[val.id] = {
            value: itemValue.files ?? [],
            setting: JSON.parse(val.setting),
            files: itemValue.files ?? [],
          };
        } else if (val.type.type_name == 'image')
          newSelectItem.fields[val.id] = {
            value: [],
            setting: JSON.parse(val.setting),
            files: val.value,
          };
        else {
          try {
            newSelectItem.fields[val.id] = JSON.parse(val.value);
          } catch {
            newSelectItem.fields[val.id] = val.value;
          }
        }
      });
      setNewUserFields(newSelectItem);
    }
  }, []);

  React.useEffect(() => {
    if (selectedTypeId && !sampleSourceSelected.id) {
      setField({
        name: '',
        description: '',
        user_fields: [],
      });
      setNewUserFields({ id: 0, fields: {} });
      clearSampleSourceField();
    }
  }, [selectedTypeId]);

  const setNewField = (key, value) => {
    const obj = JSON.parse(JSON.stringify(field));
    obj[key] = value;
    setField(obj);
    setSampleSourceField(key, value);
  };

  const addClick = () => {
    setIsClickAdd(true);

    if (!sampleSourceSelected.name || !sampleSourceSelected.description) return;
    if (sampleSourceSelected.id != null) return warningTypeSamlesWillChangeAlert(save);
    save();
  };

  const save = () => {
    const sampleSourceUpsertAsync = async () => {
      let res;
      const user_fields = configureUserFields();

      if (
        user_fields.some((field) => {
          if (field.required) {
            return field.value === undefined || field.value.value === '' || field.value === '';
          }
          return false;
        })
      )
        return;

      if (sampleSourceSelected.id != null) {
        res = await updateSampleSource(sampleSourceSelected.id, {
          ...sampleSourceSelected,
          user_fields: user_fields,
          type: selectedSourceType.id,
        });
      } else {
        res = await createSampleSource({
          ...sampleSourceSelected,
          user_fields: user_fields,
          type: selectedSourceType.id,
        });
      }
      
      if (!res.success && res.error_code === 1500)
        return showAlert('Название источника не уникально!', 'error');
      if (!res.success && res.error_code) return showAlert(`Код № ${res.error_code}!`, 'error');

      if (res.success) {
        successTypeSampleUpsertAlert();
        onUpdate();
        setModalOpened(false);
      }
    };
    sampleSourceUpsertAsync();
  };

  const successTypeSampleUpsertAlert = () =>
    showAlert(
      `Источник образца ${sampleSourceSelected.id ? 'отредактирован' : 'создан'} успешно!`,
      'success',
    );

  const warningTypeSamlesWillChangeAlert = (callback) =>
    showAlert(`Данные типа источника будут изменены!`, 'warning', callback);

  const cancelClick = () => {
    setModalOpened(false);
    clearSampleSourceField();
  };

  const resetSelectItem = () => {
    setModalOpened(false);
    setNewUserFields({ id: 0, fields: {} });
  };

  const configureUserFields = () => {
    if (newUserFields.fields) {
      const user_fields = [];
      selectedSourceType.user_fields.forEach((item) => {
        user_fields.push({ id_field: item.id_field, value: '', required: item.required });
      });
      user_fields.map((item) => {
        if (newUserFields.fields[item.id_field]) {
          if (
            newUserFields.fields[item.id_field]?.files &&
            newUserFields.fields[item.id_field]?.files.length > 0
          ) {
            item.files = newUserFields.fields[item.id_field].files.filter((file) => !!file.name);
            item.value = JSON.stringify({
              value: '',
              files: newUserFields.fields[item.id_field].files.map((file) => file.name ?? file),
            });
            return item;
          }

          return (item.value = JSON.stringify(newUserFields.fields[item.id_field]));
        }

        return item;
      });
      return user_fields;
    }
    return [];
  };

  const loadFile = (file) => {
    const fileExtension = file.split('/').pop();
    const loadFileBD = async () => {
      const res = await getFileSample(file);
      const data = new Blob([res]);
      FileSaver.saveAs(data, fileExtension);
    };
    loadFileBD();
  };

  const modal = (
    <div className={classes.modalContainer}>
      <div className={classes.modal}>
        <div className={classes.header}>
          <div className={classes.headerTitle}>
            {(disabled && 'Данные источника образца') ||
              (sampleSourceSelected.id == null ? 'Добавить' : 'Редактировать') +
                ' источник образца'}
          </div>
          <div className={styles.closeButton} onClick={() => cancelClick()}>
            <Icon color={'#1d6030'} width={'15px'} height={'15px'} src={close} />
          </div>
        </div>
        <div className={classes.modalBody}>
          {
            <div className={classes.infoItem}>
              <p className={dropStyles.infoItemName}>Тип</p>
              <Select
                options={typesSources}
                value={selectedTypeId}
                onChange={(e) => {
                  setSelectedSourceType(typesSources.find((item) => item.id == e));
                  setSelectedTypeId(e);
                }}
                titleKey="name"
                valueKey="id"
                notSelectedText="Не выбрано"
                disabled={sampleSourceSelected.id}
                hideErrorBlock={true}
              />
            </div>
          }
          {!selectedSourceType && isClickAdd && (
            <div className={baseClasses.dataErrorBlock}>
              <img src={error} alt={'error'} />
              <div className={baseClasses.dataError}>Поле обязательно для заполнения</div>
            </div>
          )}
          {selectedSourceType && (
            <>
              <p className={classes.categoryTitle}>Стандартные поля</p>
              <div className={classNames(dropStyles.infoItem, classes.standartFieldContainerFirst)}>
                <p className={dropStyles.infoItemName}>Название</p>
                <div className={dropStyles.infoItemInput}>
                  <input
                    className={dropStyles.infoItemValue}
                    value={field?.name ?? ''}
                    onChange={(e) => setNewField('name', e.target.value)}
                    disabled={disabled}
                  />
                </div>
              </div>
              {!sampleSourceSelected?.name?.trim() && isClickAdd && (
                <div className={baseClasses.dataErrorBlock}>
                  <img src={error} alt={'error'} />
                  <div className={baseClasses.dataError}>Поле обязательно для заполнения</div>
                </div>
              )}
              <div className={classNames(dropStyles.infoItem, classes.standartFieldContainer)}>
                <p className={dropStyles.infoItemName}>Описание</p>
                <div className={dropStyles.infoItemInput}>
                  <input
                    className={dropStyles.infoItemValue}
                    value={field?.description ?? ''}
                    onChange={(e) => setNewField('description', e.target.value)}
                    disabled={disabled}
                  />
                </div>
              </div>
              {!sampleSourceSelected?.description?.trim() && isClickAdd && (
                <div className={baseClasses.dataErrorBlock}>
                  <img src={error} alt={'error'} />
                  <div className={baseClasses.dataError}>Поле обязательно для заполнения</div>
                </div>
              )}
              <p className={classes.categoryTitle}>Пользовательские поля</p>
              {selectedSourceType?.user_fields.map((val, index) => {
                const handlerInputData = (data) => {
                  const newSelectItem = { ...newUserFields };
                  newSelectItem.fields[val.id_field] = data;
                  setNewUserFields(newSelectItem);
                };
                const handlerInputFile = (files) => {
                  const newSelectItem = { ...newUserFields };
                  newSelectItem[`files[${val.id_field}]`] = files;
                  setNewUserFields(newSelectItem);
                };

                let value = newUserFields.fields[val.id_field] || '';
                if ((val.type.type_name == 'file' || val.type.type_name == 'image') && disabled) {
                  return (
                    <div
                      key={index}
                      className={classNames(classes.userFieldContainer, classes.fileFieldContainer)}
                    >
                      <div>{val.name}</div>
                      <div className={classes.filesContainer}>
                        {value &&
                          value.files.map((file, index) => (
                            <div
                              key={index}
                              className={classes.fileLink}
                              onClick={() => loadFile(file)}
                            >
                              {file.split('/').pop()}
                            </div>
                          ))}
                      </div>
                    </div>
                  );
                }

                return (
                  <div key={index} className={classes.userFieldContainer}>
                    <WorkRightAddMenuItem
                      item={{
                        type: val.type.type_name,
                        name: val.name,
                        setting: JSON.parse(val.setting),
                        id: val.id_field,
                      }}
                      selectItem={value}
                      resetSelectItem={resetSelectItem}
                      showAlert={showAlert}
                      setNewSelectItem={handlerInputData}
                      setFiles={handlerInputFile}
                      isUserFieldsOperation={true}
                      disabled={disabled}
                    />
                    {isClickAdd ? (
                      val.required ? (
                        newUserFields.fields[val.id_field] ? (
                          newUserFields.fields[val.id_field].value == '' &&
                          newUserFields.fields[val.id_field].files?.length == 0 &&
                          isClickAdd && (
                            <div
                              className={classNames(
                                classes.dataErrorBlock,
                                classes.dataErrorBlockDinamyc,
                              )}
                            >
                              <img src={error} alt={'error'} />
                              <div className={classes.dataError}>
                                Поле обязательно для заполнения
                              </div>
                            </div>
                          )
                        ) : (
                          <div
                            className={classNames(
                              classes.dataErrorBlock,
                              classes.dataErrorBlockDinamyc,
                            )}
                          >
                            <img src={error} alt={'error'} />
                            <div className={classes.dataError}>Поле обязательно для заполнения</div>
                          </div>
                        )
                      ) : (
                        <></>
                      )
                    ) : (
                      <></>
                    )}
                  </div>
                );
              })}
            </>
          )}
        </div>
        <div className={classes.footer}>
          {(disabled && (
            <button className={`button_default save_style`} onClick={() => cancelClick()}>
              Ок
            </button>
          )) || (
            <>
              <button className={`button_default save_style`} onClick={() => addClick()}>
                {sampleSourceSelected.id == null ? 'Добавить' : 'Редактировать'}
              </button>
              <button className={`button_default cancel_style`} onClick={() => cancelClick()}>
                Отмена
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
};

export default AddSampleSourceModal;
